// The coins BFF router was decommissioned along with je-client. This hook is
// retained as an inert stub so obsolete coins UI still compiles; it no longer
// fetches the next expiring credit.
export type ErrorResponse = null;

export const useFetchNextExpiringCredit = () => {
  return {
    data: undefined as { credit?: any } | undefined,
    isError: false,
    error: null as ErrorResponse,
    isLoading: false
  };
};
